/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TrainingCourseGroup } from '../../models/training-course-group';

export interface ApiMasterTrainingGetActiveForApplicationGet$Params {
}

export function apiMasterTrainingGetActiveForApplicationGet(http: HttpClient, rootUrl: string, params?: ApiMasterTrainingGetActiveForApplicationGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TrainingCourseGroup>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTrainingGetActiveForApplicationGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TrainingCourseGroup>>;
    })
  );
}

apiMasterTrainingGetActiveForApplicationGet.PATH = '/api/Master/Training/GetActiveForApplication';
